import React from 'react';
import './Loader.css';

export default function Loader({ message }) {
  return (
    <div className="loader-overlay">
      <div className="loader-aurora" />
      <div className="loader-stars">
        {Array.from({ length: 30 }).map((_, i) => (
          <div key={i} className="loader-star" style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`,
            animationDuration: `${2 + Math.random() * 3}s`
          }} />
        ))}
      </div>
      <div className="loader-container">
        <div className="loader-ring loader-ring-1" />
        <div className="loader-ring loader-ring-2" />
        <div className="loader-ring loader-ring-3" />
        <div className="loader-orbit">
          <div className="loader-particle p1" />
          <div className="loader-particle p2" />
          <div className="loader-particle p3" />
          <div className="loader-particle p4" />
          <div className="loader-particle p5" />
          <div className="loader-particle p6" />
        </div>
        <div className="loader-logo-wrap">
          <div className="loader-logo-glow" />
          <img src="/uvw.png" alt="UVW" className="loader-logo" />
        </div>
      </div>
      <div className="loader-text">
        <span className="loader-title">UVW</span>
        <span className="loader-subtitle">{message || 'Loading...'}</span>
        <div className="loader-dots">
          <span className="loader-dot" />
          <span className="loader-dot" />
          <span className="loader-dot" />
        </div>
      </div>
    </div>
  );
}
